document.addEventListener('DOMContentLoaded', () => {
    if (!window.levonaIsHome) return;
  // Solo ejecutar en la página de inicio

  const headerSection = document.querySelector('.section-header');
  const banner = document.querySelector('#levona-home-hero');

  if (!headerSection || !banner) return;

  function updateHeader() {
    const bannerBottom = banner.getBoundingClientRect().bottom;
    const headerHeight = headerSection.offsetHeight;

    if (bannerBottom > headerHeight) {
      document.body.classList.add('levona-home');
    } else {
      document.body.classList.remove('levona-home');
    }
  }

  updateHeader();

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader);
});
